<template>
  <div
    id="form-search-popover"
    class="component-card container-app-search">
    <j-title-header :options="title"/>

    <div class="d-flex m__b--20">
      <div
        :class="{'tab-experience-manager-active' : tabSelected === 'tugas'}"
        class="tab-experience-manager m__r--15 p__l--10 p__r--10"
        @click="selectTab('tugas')">
        SURAT TUGAS
      </div>
      <div
        :class="{'tab-experience-manager-active' : tabSelected === 'keputusan'}"
        class="tab-experience-manager m__r--15 p__l--10 p__r--10"
        @click="selectTab('keputusan')">
        SURAT KEPUTUSAN
      </div>
    </div>

    <v-server-table
      v-show="load_first"
      ref="tableServer"
      :columns="tabSelected === 'tugas' ? columns : columnsSK"
      :options="options"
      class="jTable"
      @loading="loading"
      @loaded="loaded"
      @row-click="clickDetail">
      <div
        slot="pegawai"
        slot-scope="props">
        <div
          v-for=" (item, index) in props.row.pegawai"
          :key="index">
          <div>- {{ item }}</div>
        </div>
      </div>
    </v-server-table>
    <jLoadingTable v-if="!load_first"/>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions } from 'vuex';
import jApiKurikulum from '@/services/jApiKurikulum';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';

export default {
  components: {
    jLoadingTable,
  },
  data() {
    return {
      title: {
        icon: 'fa-file',
        main_title: 'Report Administrasi Surat Menyurat',
      },
      tabSelected: 'tugas',
      load_first: false,
      length_table: '',
      data_table: [],
      selected_rows: [],
      columns: ['title', 'pegawai', 'maksud_perjalanan_dinas', 'mulai_acara', 'akhir_acara'],
      columnsSK: ['title', 'pegawai'],
      options: {
        headings: {
          title: 'DESKRIPSI TUGAS',
          pegawai: 'NAMA PEGAWAI',
          maksud_perjalanan_dinas: 'TUJUAN',
          mulai_acara: 'TANGGAL MULAI ACARA',
          akhir_acara: 'TANGGAL AKHIR ACARA',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: false,
        sortable: [],
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            limit: data.limit,
            page: data.page,
            module_id: data.module,
            category_id: data.category_id,
          };
        },
        requestFunction(data) {
          const getList = jApiKurikulum.getListAdminPembelajaranReport(data);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },
    };
  },
  computed: {
  },
  watch: {
    filter_data(val) {
      if (val === '') {
        this.$refs.tableServer.setFilter('');
      }
    },
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),

    selectTab(status) {
      this.options.headings.title = status === 'tugas' ? 'DESKRIPSI TUGAS' : 'DESKRIPSI SK';
      this.tabSelected = status;
      this.refreshTable();
    },

    loading(val) {
      const a = val;
      a.module_id = 2;

      switch (this.tabSelected) {
        case 'tugas':
          a.category_id = 5;
          break;
        case 'keputusan':
          a.category_id = 4;
          break;
        case 'agenda':
          a.category_id = 6;
          break;
        default :
          a.category_id = 0;
      }

      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;

      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    refreshTable() {
      this.$refs.tableServer.getData();
    },

    filter(val) {
      this.$refs.tableServer.setFilter(val);
    },

    downloadSurat(url) {
      window.open(url);
    },

    clickDetail({ row }) {
      this.$router.replace(`/admin-surat/kepsek/detail/${row.id}`);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kurikulum/admin-surat/jAdminSuratReportList.vue